import { t } from 'i18next'

import { ResidentAppError } from '../../../../common/error'
import {
  ContractType,
  TerminationDisallowedReason,
} from '../../../../common/types'
import { resolveContractTerminationTerminology } from '../utils/resolveContractTerminationTerminology'

export const useTerminationDisallowedReason = (
  reason: TerminationDisallowedReason | undefined,
  contractType: ContractType
) => {
  const terminology = resolveContractTerminationTerminology(contractType)
  const resolveTerminationDisallowedReason = () => {
    switch (reason) {
      case undefined:
        return undefined

      case TerminationDisallowedReason.CONTRACT_TERMINATED:
        return t(
          'terminateContract:terminationDisallowedReason.contractTerminated'
        )

      case TerminationDisallowedReason.HAS_GUARDIAN_OF_INTERESTS:
        return t(
          'terminateContract:terminationDisallowedReason.hasGuardianOfInterests'
        )

      case TerminationDisallowedReason.IS_ESTATE_CONTRACT:
        return t(
          'terminateContract:terminationDisallowedReason.isEstateContract'
        )

      case TerminationDisallowedReason.MISSING_RESIDENT_USERS:
        return t(
          'terminateContract:terminationDisallowedReason.missingResidentUsers'
        )

      case TerminationDisallowedReason.PENDING_TERMINATION_REVIEW:
        return t(
          'terminateContract:terminationDisallowedReason.pendingTerminationReview'
        )

      case TerminationDisallowedReason.PENDING_TERMINATION_TENANT_APPROVALS:
        return t(terminology.pendingTenantApprovalsDisallowedReason)

      case TerminationDisallowedReason.CONTRACT_TAG:
        return t('terminateContract:terminationDisallowedReason.contractTags')

      case TerminationDisallowedReason.NOT_CONTRACT_PARTY:
        return undefined

      case TerminationDisallowedReason.TENANTS_WITH_UNDETERMINED_AGE:
        return t(
          'terminateContract:terminationDisallowedReason.tenantsWithUndeterminedAge'
        )
      case TerminationDisallowedReason.HAS_COMPANY_TENANT:
        return t(
          'terminateContract:terminationDisallowedReason.hasCompanyTenant'
        )
      case TerminationDisallowedReason.PENDING_MODIFICATION_REQUEST:
        return t(
          'terminateContract:terminationDisallowedReason.pendingModificationContract'
        )
      case TerminationDisallowedReason.NOT_STARTED_YET:
        return t('terminateContract:terminationDisallowedReason.notStartedYet')
      case TerminationDisallowedReason.OPEN_CONTINUATION_OFFER:
        return t(
          'terminateContract:terminationDisallowedReason.openContinuationOffer'
        )
      case TerminationDisallowedReason.PENDING_CONTRACT_RESIGN:
        return t(
          'terminateContract:terminationDisallowedReason.pendingContractResign'
        )
      default: {
        throw ResidentAppError.ClientError('UNKNOWN', {
          message: `Unknown termination reason: ${reason}`,
        })
      }
    }
  }

  return { terminationDisallowedReason: resolveTerminationDisallowedReason() }
}
